import Vue from 'vue';
import Calendar from 'v-calendar/src/components/Calendar.vue';

Vue.component('VCalendar', Calendar);
